export const teamList = [
    {
        id:'0',
        name: 'Ferretería Liviana',
        position: 'Position',
        imageId: 'DD01'
    },
    {
        id:'1',
        name: 'Pinturas y Selladores',
        position: 'Position',
        imageId: 'DD02'
    },
    {
        id:'2',
        name: 'Pesca, Caza, Defensa',
        position: 'Position',
        imageId: 'DD03'
    },
    {
        id:'3',
        name: 'Accesorios de Bicicletas',
        position: 'Position',
        imageId: 'DD04'
    },
    {
        id:'4',
        name: 'Tornillería variada',
        position: 'Position',
        imageId: 'DD05'
    },
    {
        id:'5',
        name: 'Hogar',
        position: 'Position',
        imageId: 'DD06' 
    },
    {
        id:'6',
        name: 'Artículos para Autos',
        position: 'Position',
        imageId: 'DD07'
    },
    {
        id:'7',
        name: 'Materiales de Construcción',
        position: 'Position',
        imageId: 'DD08' 
    },
    {
        id:'8',
        name: 'Plomería',
        position: 'Position',
        imageId: 'DD09' 
    },
    {
        id:'9',
        name: 'Computadoras y Accesorios',
        position: 'Position',
        imageId: 'DD010' 
    },
    {
        id:'10',
        name: 'Copias de Llaves',
        position: 'Position',
        imageId: 'DD011' 
    },
    {
        id:'11',
        name: 'Artículos para animales',
        position: 'Position',
        imageId: 'DD012' 
    },
    {
        id:'12',
        name: 'Bocínas y karaoke',
        position: 'Position',
        imageId: 'DD013' 
    },
    {
        id:'13',
        name: 'Juguetes',
        position: 'Position',
        imageId: 'DD014' 
    },
]